export default __webpack_public_path__ + "static/media/profile-icon.29184190.png";